import * as React from "react";
import {useEffect} from "react";
import OdxAreaHeader from '../../../OdxComponents/NativeOdx/Odx-AreaHeader'
import OdxCard from '../../../OdxComponents/NativeOdx/Odx-Card'
import {transformOdxLayoutRef} from '../../../OdxComponents/odxLayoutRef'
import {odxIconSets, odxVariants} from "../../../OdxComponents/constants";
import OdxIcon from "../../../OdxComponents/NativeOdx/Odx-Icon";
import {useMain} from "../../../Utils/SessionControls/mainContext";
import {IToast} from "../../../Utils/SessionControls/mainProvider";
import {useModuleViewTracking} from "../../../Utils/sentryTracking";
import {simplifyForHtmlId} from "../../../Utils/transformer";

const HelpAndAbout: React.FC = () => {
    const {createToast} = useMain();
    const baseId = 'hub-help-about';

    const containerRef = React.useRef<HTMLDivElement>(null);
    useModuleViewTracking('hub-helpandabout')

    useEffect(() => {
        transformOdxLayoutRef(containerRef.current)
    }, [])

    const copyToClipboard = async (text: string) => {
        await navigator.clipboard.writeText(text);
        createToast({
            title: "Copied to clipboard",
            variant: "default"
        } as IToast)
    }

    const CopyButton = (text: string) => {
        const buttonId = `${baseId}-copy-${simplifyForHtmlId(text)}`;
        return (
            <span onClick={() => copyToClipboard(text)}
                  id={buttonId}
                  className={"odx-link cursor-pointer"}>
            <OdxIcon name={"copy-content"}
                     size={"sm"}
                     iconSet={odxIconSets.core}

            />
            </span>
        );
    }

    return <>
        <OdxAreaHeader text={"Help and About"} className={"!pl-0"} odxSize={"large"} id={`${baseId}-header`}/>

        <div ref={containerRef} id={`${baseId}-view`}>
            <div data-odxLayout={"grid 6 vertical-center"} id={`${baseId}-cards`}>
                <OdxCard title={"About"} className={"h-full !cursor-default"} id={`${baseId}-card-about`}>
                    <p id={`${baseId}-about-text`}>
                        The DevSecOps Hub is the single point of entry for all applications provided by the DevSevOps
                        Platform. This is valid for Dräger applications (like DPOD, DOOP, DPAS, IDMS), of the shelf
                        solutions hosted by Dräger (SonarQube) and SaaS-Solutions (like Azure DevOps, Sentry.IO,
                        Statuspage.IO, Apple AppStore).
                    </p>
                </OdxCard>
                <OdxCard title={'Help'} className={"h-full !cursor-default"} id={`${baseId}-card-help`}>
                    <p id={`${baseId}-help-text`}>
                        If you need further help or found a bug, create a ticket to DLCDE-IT-MS
                        DevOps {CopyButton("DLCDE-IT-MS DevOps")} in SNOW.
                        Alternatively, you can send an email to <a className={'odx-link'}
                                                                   href={"mailto:help@draeger.com"}
                                                                   id={`${baseId}-help-email`}> help@draeger.com </a> and
                        reference to our resolver group.
                    </p>
                </OdxCard>
                <OdxCard title={'API'} className={"h-full !cursor-default"} id={`${baseId}-card-api`}>
                    <p id={`${baseId}-api-text`}>
                        The DevSecOps Hub and all of its modules have an API that you can use: <a className={'odx-link'}
                                                                                                  target={"_blank"}
                                                                                                  rel={"noreferrer"}
                                                                                                  href={'https://func-devsecopshub-prod.azurewebsites.net/api/swagger/ui'}
                                                                                                  id={`${baseId}-api-link`}>API
                        Docs</a>
                    </p>
                </OdxCard>
            </div>
        </div>
    </>

}

export default HelpAndAbout;
